import { Component, OnInit, OnDestroy,ViewChild,ElementRef,AfterViewInit } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'ng2-meta';
import { CopyWriteService} from './../services/copywrite.service';

interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  address: string;
  email: string;
  contactno: string;
    
}
@Component({
    
	//template: require('./home.component.html'),
	templateUrl: './pg/home/home.component.html',	
	
})
export class HomeComponent implements OnInit{
	
	public siteinfo;
	pagedata: PageData;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private metaService: MetaService,
	    private copywriteservice:CopyWriteService,
	    private _title: Title
	    ) {		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: '',
                  address:'',
                  email:'',
                  contactno:''                 
				  	}				 
		 /*  this.ContactUsForm = this.fb.group({
			   email: ["", Validators.required],
			   name: ["", Validators.required]
			   });	*/
		   
		   
		   	   
	    }
	 ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh hhhnaga";
	   // alert("page");
	 // this.siteinfo=;    
	   
       window.scrollTo(0, 0);
      setTimeout(()=>{    //<<<---    using ()=> syntax
         
         

      this.siteinfo=this.shareService.getsiteinfo();    
           
     // this._title.setTitle(this.siteinfo.meta_title);
     if(this.siteinfo)
     {
       
       
      this.metaService.setTitle(this.siteinfo.meta_title);
     // this.pagedata.description=this.siteinfo.meta_description;
      this.metaService.setTag('og:title',this.siteinfo.meta_title);
	  this.metaService.setTag('description',this.siteinfo.meta_description);
	  this.metaService.setTag('keywords',this.siteinfo.meta_keywords);
	  }
	   let copywrite=this.shareService.getcopywrite();  
			      //console.log("Mydata->"+this.siteinfo.site_address);        
	   this.copywriteservice.copywritelogo(copywrite);
	   
	  
	  console.log("inside home page"+this.siteinfo.meta_description);
	   
	  },2000);
	 
	  
	
	 

		
	
		
	}
	
	
	
}



// WEBPACK FOOTER //
// ./resources/assets/typescript/home/home.component.ts